import { MattersActions } from '@/matter/store/slice'
import type { AppDispatch } from '@/store/store'
import { ApiError } from '@/util/errors/api-error'

export function refreshMatterAfterWriteAccessError(error: unknown, matterId: string | undefined, dispatch: AppDispatch): void {
  if (!(error instanceof ApiError) || (error.status !== 403 && error.status !== 404) || !matterId) return

  dispatch(MattersActions.refreshMatterDetail({ matterId, forceRefresh: true }))
}
